import React from 'react';
import Icon from '../AppIcon';
import Button from './Button';

const ConfirmationDialog = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title = 'Confirm Action', 
  message = 'Are you sure you want to proceed?', 
  confirmText = 'Confirm', 
  cancelText = 'Cancel',
  variant = 'destructive',
  loading = false,
  icon = 'AlertTriangle'
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-background/80 backdrop-blur-sm z-[1500] flex items-center justify-center p-4">
      <div className="bg-card rounded-xl shadow-elevation-5 w-full max-w-md">
        <div className="p-6">
          <div className="flex items-start gap-4 mb-4">
            <div className={`w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 ${
              variant === 'destructive' ? 'bg-destructive/10' :
              variant === 'danger' ? 'bg-error/10' :
              variant === 'warning'? 'bg-warning/10' : 'bg-primary/10'
            }`}>
              <Icon 
                name={icon} 
                size={24} 
                color={`var(--color-${
                  variant === 'destructive' ? 'destructive' :
                  variant === 'danger' ? 'error' :
                  variant === 'warning'? 'warning' : 'primary'
                })`}
              />
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-heading font-semibold text-foreground mb-2">
                {title}
              </h3>
              <p className="text-sm text-muted-foreground">
                {message}
              </p>
            </div>
          </div>

          <div className="flex gap-3 mt-6">
            <Button
              variant="outline"
              onClick={onClose}
              fullWidth
              disabled={loading}
            >
              {cancelText}
            </Button>
            <Button
              variant={variant}
              onClick={onConfirm}
              fullWidth
              loading={loading}
              disabled={loading}
            >
              {confirmText}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationDialog;